import React from 'react'

interface IAttachment {
  documentName: string
  handleRemoveDocument: (documentKey: number) => void
  documentKey: number
}

export default function Attachment(props: IAttachment) {
  const { documentName, handleRemoveDocument, documentKey } = props

  return (
    <div className='flex flex-col text-xs gap-2'>
      <div
        className='flex flex-row bg-sky-300 w-full p-2 rounded-sm
        justify-between items-center justify-items-center'
      >
        <div className='w-11/12'>
          <p
            className='font-bold whitespace-nowrap
            text-ellipsis overflow-hidden'
          >
            {documentName}
          </p>
        </div>
        <div
          className='w-1/12 text-center'
          onClick={() => handleRemoveDocument(documentKey)}
        >
          <p className='font-bold cursor-pointer'>x</p>
        </div>
      </div>
    </div>
  )
}
